import { render, staticRenderFns } from "./MasterQuotation.vue?vue&type=template&id=51369332&scoped=true&"
import script from "./MasterQuotation.vue?vue&type=script&lang=js&"
export * from "./MasterQuotation.vue?vue&type=script&lang=js&"
import style0 from "../SalesForce.scss?vue&type=style&index=0&id=51369332&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51369332",
  null
  
)

export default component.exports